module.exports = __webpack_public_path__ + "img/25.686a313d.png";